module.exports = __webpack_public_path__ + "img/xl_icon.4e0c8840.png";